<template>
  <transition
    name="s-zoom-in-bottom">
    <v-snackbar
      v-show="showToolbar"
      class="my-auto white--text snackbar actions-snackbar"
      color="var(--black-color)"
      :content-class="'flex'"
      :timeout="-1"
      transition="scale-transition"
      :value="show">
      <TendersActionsToolbar
        v-if="showItems.tendersActions"
        :options="options"
        @showActions="(val) => componentShowActions.tendersActions = val.toolbar"/>
      <OffersActionsToolbar
        v-if="showItems.lotOffersActions"
        :options="options"
        :reject_condition.sync="reject_condition"
        @showActions="(val) => componentShowActions.lotOffersActions = val.toolbar"/>
      <OffersGroupActionsToolbar
        v-if="showItems.lotGroupOffersActions"
        :options="options"
        @showActions="(val) => componentShowActions.lotGroupOffersActions = val.toolbar"/>
      <CompareActionsToolbar
        v-if="showItems.compareActions"
        :options="options"
        :reject_condition.sync="reject_condition"/>
      <PurchasingActionsToolbar
        v-if="showItems.purchasingActions"
        :options="options"
        :reject_condition.sync="reject_condition"
        @showActions="(val) => componentShowActions.purchasingActions = val.toolbar"/>
      <PurchasingItemActionsToolbar
        v-if="showItems.purchasingItemActions"
        :options="options"
        :reject_condition.sync="reject_condition"
        @showActions="(val) => componentShowActions.purchasingItemActions = val.toolbar"/>
      <PlanningActionsToolbar
        v-if="showItems.planningActions"
        :options="options"/>
      <ChooseWinnerBtn
        v-if="showItems.chooseWinner"
        :options="options"
        @showActions="(val) => componentShowActions.chooseWinner = val.toolbar"/>
      <template v-if="showItems.orgSettings">
        <sButton
          color="var(--white-color)"
          icon="copy"
          type="text"
          @click="$root.$emit('actionOrgSettings', {name: 'copy', params: options.params})">
          {{ $t('Common.Copy') }}
        </sButton>
        <sButton
          color="var(--white-color)"
          icon="delete"
          type="text"
          @click="$root.$emit('actionOrgSettings', {name: 'delete', params: options.params})">
          {{ $t('Purchasing.Remove') }}
        </sButton>
      </template>
      <div
        v-if="reject_condition && options.rejectChoosed"
        class="ml-1 my-auto">
        <sButton
          color="var(--white-color)"
          icon="cross"
          small
          type="text"
          @click="options.rejectChoosed"/>
      </div>
    </v-snackbar>
  </transition>
</template>
<script>
import ChooseWinnerBtn from 'components/tenders/tender page/ChooseWinnerBtn.vue'
import PlanningActionsToolbar from 'components/planning/PlanningActionsToolbar.vue'
import PurchasingActionsToolbar from 'components/purchasing/PurchasingActionsToolbar.vue'
import OffersActionsToolbar from 'components/tenders/actions toolbar/OffersActionsToolbar.vue'
import CompareActionsToolbar from 'components/tenders/actions toolbar/CompareActionsToolbar.vue'
import TendersActionsToolbar from 'components/tenders/actions toolbar/TendersActionsToolbar.vue'
import OffersGroupActionsToolbar from  'components/tenders/actions toolbar/OffersGroupActionsToolbar.vue'
import PurchasingItemActionsToolbar from 'components/purchasing/purch item/PurchasingItemActionsToolbar.vue'
import { tenderMixin } from 'mixins'

export default {
  name: 'actionsToolbar',
  mixins: [tenderMixin],
  data () {
    return {
      show: false,
      options: {},
      loading: false,
      reject_condition: false,
      componentShowActions: {
        tendersActions: false,
        lotOffersActions: false,
        lotGroupOffersActions: false,
        purchasingActions: false,
        purchasingItemActions: false,
        emptyComponents: false,
        chooseWinner: false,
      },
      showItems: {
        tendersActions: false,
        lotOffersActions: false,
        lotGroupOffersActions: false,
        compareActions: false,
        purchasingActions: false,
        purchasingItemActions: false,
        planningActions: false,
        chooseWinner: false,
        orgSettings: false,
      }
    }
  },
  mounted() {
    this.$root.$on('showSnackbar', this.onShowSnackbar)
    this.$root.$on('changeSnackbar', this.oncChangeSnackbar)
    this.$root.$on('closeSnackbar', this.onCloseSnackbar)
  },
  beforeDestroy() {
    this.$root.$off('showSnackbar', this.onShowSnackbar)
    this.$root.$off('changeSnackbar', this.oncChangeSnackbar)
    this.$root.$off('closeSnackbar', this.onCloseSnackbar)
  },
  computed: {
    showToolbar() {
      return this.componentShowActions.tendersActions ||
        this.componentShowActions.lotOffersActions ||
        this.componentShowActions.lotGroupOffersActions ||
        this.componentShowActions.purchasingActions ||
        this.componentShowActions.purchasingItemActions ||
        this.componentShowActions.chooseWinner ||
        this.componentShowActions.emptyComponents ||
        this.showItems.orgSettings
    },
  },
  methods: {
    async onShowSnackbar(options) {
      if (options.tender && !options.tender.tenderAccess) {
        await this.$_updateTenderAccess(options.tender)
      }
      this.options = {}
      this.options = options
      if ( options.name ) {
        this.show = true
      }
    },
    oncChangeSnackbar(options) {
      this.show = false
      setTimeout(() => {
        this.options = Object.assign(this.options, options)
        this.show = true
      }, 200)
    },
    onCloseSnackbar() {
      this.show = false
      this.options = {}
      Object.keys(this.componentShowActions).forEach((key) => {
        this.componentShowActions[key] = false
      })
    },
    checkShowItems() {
      this.showItems.tendersActions = this.options?.name === 'tenders'
      this.showItems.lotOffersActions = this.options?.name === 'lot-offers' || this.options?.name === 'members' || this.options?.name === 'lot-offers-history'
      this.showItems.lotGroupOffersActions = this.options?.name === 'lot-group-offers'
      this.showItems.compareActions = this.options?.name === 'compare'
      this.showItems.purchasingActions = this.options?.name === 'applications'
      this.showItems.purchasingItemActions = this.options?.name === 'item'

      this.showItems.planningActions = this.options?.name === 'planning'
      this.showItems.chooseWinner = this.options?.name === 'change-winner'
      this.showItems.orgSettings = this.options?.name === 'orgSettings'

      this.componentShowActions.emptyComponents = ['planning', 'compare'].includes(this.options?.name)
    }
  },
  watch: {
    '$route'() {
      this.onCloseSnackbar()
    },
    'options.name'() {
      this.checkShowItems()
    }
  },
  components: {
    ChooseWinnerBtn,
    OffersActionsToolbar,
    TendersActionsToolbar,
    CompareActionsToolbar,
    PlanningActionsToolbar,
    PurchasingActionsToolbar,
    OffersGroupActionsToolbar,
    PurchasingItemActionsToolbar
  }
}

</script>
<style lang="scss">
.snackbar {
  z-index: 2054;
  .v-snack__wrapper {
    min-width: unset;
    max-width: 90vw;
    border-radius: 30px;

    .snackbar-enter-active, .snackbar-leave-active {
      transition: opacity .3s ease;
    }
    .snackbar-enter, .snackbar-leave-active
    {
      opacity: 0;
    }
    .snackbar {
      .outlined-btn {
        border-width: 2px;
        height: 40px;
      }

    }
    .v-btn, .btn {
      color: white !important;
      font-weight: 500;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.03em;
    }
    .v-snack__content {
      padding: 0 8px;
      max-height: 52px;
    }
    .v-snack__action {
      display: none;
    }
    .s-badge__badge {
      color: var(--black-color);
      min-height: 18px;
      height: 18px;
      min-width: 18px;
      font-size: 11px;
      line-height: 11px;
    }
  }
  .v-btn.v-btn--disabled {
    color: rgba(255, 255, 255, 0.5) !important;
  }
}
</style>
